module.exports = __webpack_public_path__ + "static/media/Logo.253c2220.png";